import { SymbolKey } from '@/pages/Markets/MarketsComponents/types';

export function parseSymbolKey(value: string): SymbolKey {
  const parsedValue = value.split(' ');

  return {
    Code: parsedValue[0],
    Period: parsedValue[3],
    PeriodType: parsedValue[2],
    TimeRef: parsedValue[1]
  };
}

export function parseSymbolKeys(value: string): SymbolKey[] {
  const parsedValues = value.split('|').map(item => item.trim());
  return parsedValues.map(parseSymbolKey);
}
